import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 图片方法插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// 百度地图

// import BaiduMap from 'vue-baidu-map'

// Vue.use(BaiduMap, {
//   ak: '3bVHdeo2ZZaZO4QczC63d0kMsbA55ZSD'
// })



// elm-ui
import 'element-ui/lib/theme-chalk/index.css';
import {
    Menu,
    Submenu,
    MenuItem,
    Carousel,
    CarouselItem,
    Tabs,
    TabPane,
    Backtop,
    Icon,
    Message,
} from 'element-ui';
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Backtop);
Vue.use(Icon);

Vue.prototype.$message = Message;


// 图片放插件引用
Vue.use(Viewer,{
    defaultOptions: {
        zIndex: 9999
    }
});
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

// 解决scoped问题，引入公共样式
import '@/assets/css/public.css'





Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
